import req from '../http';
import urls from '../../utils/config';
const marketUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_MARKETURL: urls['marketUrl']

export const getCommonGetCouponPic = params => req('post', '/client/activity/commongetcoupon/getCommonGetCouponPic', params, {
    baseURL: marketUrl,
}); // 查询活动顶图和底图接口

export const getCommonGetCoupon = params => req('post', '/client/activity/commongetcoupon/getCommonGetCoupon', params, {
    baseURL: marketUrl,
}); // 领取通用领券接口

export const getProvinceCity = params => req('post', '/client/common/region/getProvinceCity', params, {
    baseURL: marketUrl,
}); //城市
export const bindChannel = params => req('post', '/client/common/channel/bindChannel', params, {
    baseURL: marketUrl,
}); //车主认证的渠道接口

export const savePubliclyRecord = params => req('post', '/client/activity/info/savePubliclyRecord', params, {
    baseURL: marketUrl,
}); //招募活动

export const getCommonGetCouponList = params => req('post', '/client/activity/commongetcoupon/getCommonGetCouponList', params, {
    baseURL: marketUrl,
}); // 领取通用领券list券
 
